import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { CurrentUserSelectors } from '@core/account-data';

@Injectable({ providedIn: 'root' })
export class EvaluationPanelTooltipService {
  private readonly store = inject(Store);

  public readonly used = this.store.selectSignal(
    CurrentUserSelectors.featureDiscovery({ feature: 'evaluationPanelTooltipUsed' }),
  );
}
